@if (hasData) {
  <div class="dashboard-chart-container">
    <div class="chart-section">
      <div class="dashboard-chart"></div>
    </div>
    <div class="chart-details">
      <div class="total-emissions">
        <span class="value">{{ totalEmissions.toFixed(1) }}</span>
        <span class="unit">kg CO₂</span>
      </div>
      <div class="legend">
        @for (category of todayEmissions; track category) {
          <div class="legend-item">
            <span class="legend-color" [style.background-color]="category.color"></span>
            <span class="legend-label">{{ category.label }}</span>
            <span class="legend-value">{{ category.emissions.toFixed(1) }} kg</span>
          </div>
        }
      </div>
    </div>
  </div>
} @else {
  <div class="empty-chart">
    <app-icon [name]="'chart_bar_column'" [color]="'#ccc'" [size]="'48px'"></app-icon>
    <p class="empty-chart-message">No emissions data for today yet</p>
    <p class="empty-chart-subtitle">Start tracking your daily activities to see your CO₂ footprint</p>
  </div>
}

